import { AdsHandlerActionTypes } from './adsHandler.types';

const adsHandlerPagesRequest = () => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_PAGES_REQUEST,
});

const adsHandlerPagesSuccess = payload => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_PAGES_SUCCESS,
  payload,
});

const adsHandlerPagesFailure = () => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_PAGES_FAILURE,
});

const adsHandlerDraftsRequest = () => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_DRAFTS_REQUEST,
});

const adsHandlerDraftsSuccess = payload => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_DRAFTS_SUCCESS,
  payload,
});

const adsHandlerDraftsFailure = () => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_DRAFTS_FAILURE,
});

const actions = {
  pages: {
    request: adsHandlerPagesRequest,
    success: adsHandlerPagesSuccess,
    failure: adsHandlerPagesFailure,
  },
  drafts: {
    request: adsHandlerDraftsRequest,
    success: adsHandlerDraftsSuccess,
    failure: adsHandlerDraftsFailure,
  },
};

export default actions;
